<template>
<div>
    <div v-if="laravelErrors.active" class="text-xs-center mb-3">
        <v-chip v-for="(msg,key) in laravelErrors.messages" :key="key" label color="red" text-color="white">{{ msg[0] }}
        </v-chip>
    </div>
    <v-form @submit.prevent="createNotification">
        <v-layout row wrap>
            <v-flex xs12 px-2>
                <v-textarea placeholder="System notification message goes here" rows="3" box name="message" label="Message" v-model="message">
                </v-textarea>
            </v-flex>
            <v-flex xs6 px-2>
                <v-select :items="['success', 'info', 'warning', 'error']" label="Type" v-model="type" name="type">
                </v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs4 px-2>
                <v-checkbox v-model="enabled" label="Active" name="enabled">
                </v-checkbox>
            </v-flex>
            <v-flex xs12 mt-3>
                <v-btn class="white--text blue darken-1" :loading="loading" @click="createNotification()">Add</v-btn>
                <v-btn class="white--text blue darken-1" @click="$emit('close')">Cancel</v-btn>
            </v-flex>
        </v-layout>
    </v-form>

    <v-dialog v-model="successAlert" max-width="500px">
        <v-card>
            <v-card-text>
                <v-alert :value="true" type="success">Notification successfully created!</v-alert>
            </v-card-text>
            <v-card-actions>
                <v-btn flat color="primary" @click.stop="successAlert = false">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
export default {
    props: ['active'],
    data() {
        return {
            loading: false,
            message: '',
            type: '',
            enabled: false,
            successAlert: false
        }
    },
    computed: {
        laravelErrors() {
            return this.$store.state.errorModule.validation
        }
    },
    watch: {
        'active': function (value) {
            if (!value) {
                this.message = ''
                this.type = ''
                this.enabled = false
                this.$store.commit('clearErrors')
            }
        }
    },
    methods: {
        createNotification() {
            this.loading = true
            this.$store.commit('clearErrors')

            let notification = {
                message: this.message,
                type: this.type,
                active: this.enabled
            }

            this.$store.dispatch('createNotification', notification).then(() => {
                    this.loading = false
                    this.successAlert = true
                    this.$emit('close')
                })
                .catch(() => {
                    this.loading = false
                })
        },
    }
}
</script>
